import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig'

import { store } from '../_helpers/store';
import { authHeader } from '../_helpers/auth-header'

export const questionnaireService = {
  get,
  copy,
  save,
  getAll,
};

function copy(questionnaireId, name) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/questionnaire/${questionnaireId}/copy`,
    headers: authHeader(),
    data: { name }
  }).then((response) => {
    return response.data;
  })
}

function get(questionnaireId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/questionnaire/${questionnaireId}`,
    headers: authHeader(),
  }).then((response) => {
    return response.data;
  })
}

function getAll() {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/questionnaire`,
    headers: authHeader(),
  }).then((response) => {
    return response.data;
  });
}

function save(questionnaireId = null, questionnaire, noteTemplate, document) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: questionnaireId ? 'PATCH' : 'POST',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/questionnaire${questionnaireId ? `/${questionnaireId}` : ''}`,
    headers: authHeader(),
    data: {
      resource: questionnaire,
      noteTemplate: noteTemplate,
      document: document
    }
  })
}